import { createContext, useContext } from "react";

/** The classic nav row's fills: a translucent hover that lets the nav's background through, and a solid active row. */
export const navItemBg = {
  hover: "whiteAlpha.40",
  active: "white",
};

/** The product nav's fills: on its `base.background`, a step darker on hover and another when pressed or open. */
export const productNavItemBg = {
  hover: "base.backgroundHover",
  pressed: "base.backgroundPressed",
  active: "white",
};

// Box-shadow is left out: it repaints every frame, so the row's shadow snaps while its fill fades.
export const navItemTransitions = {
  transitionProperty: "background-color, border-color, color",
  transitionDuration: "fast",
  transitionTimingFunction: "easeOutQuad",
};

/** A nav row's height as a size token: 32px, and 40px in the phone's sheet, where a finger presses it. */
export const NavRowHeightContext = createContext<8 | 10>(8);

export const useNavRowHeight = () => useContext(NavRowHeightContext);
